// **********************************************************
// Technical Specs
// **********************************************************

const technicalSpecsSlider = document.querySelectorAll('[data-slider="technical-specs-slider"]');

const technicalSpecsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 15,
  speed: 800,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1023: {
      slidesPerView: 3.1,
      spaceBetween: 24,
    },
    1440: {
      slidesPerView: 4.1,
      spaceBetween: 24,
    },
    1920: {
      slidesPerView: 5,
      spaceBetween: 24,
    },
  },
};

technicalSpecsSlider.forEach((el) => {
  const parentElem = el.closest('.technical-specs');
  const paginationElement = parentElem.querySelector('.swiper-pagination');

  const arrowRight = parentElem.querySelector('.next-button');
  const arrowLeft = parentElem.querySelector('.prev-button');

  technicalSpecsSliderOptions.navigation.nextEl = arrowRight;
  technicalSpecsSliderOptions.navigation.prevEl = arrowLeft;

  technicalSpecsSliderOptions.pagination.el = paginationElement;
  new Swiper(el, technicalSpecsSliderOptions);
});
